export default {
  websiteBaseUrl: 'http://next:3000',
  apiBaseUrl: 'https://www.roomvu.com/api',
  dashboardBaseUrl: 'http://next:3000/dashboard',
  imgBaseUrl: 'https://www.roomvu.com/',
  useProxyForApiCall: true,
  displayAnalyticLogs: false,
  auth: {
    loginUrl: 'https://www.roomvu.com/login',
    loginApiUrl: '/user/login',
    userAuthenticationUrl: '/user/get',
  },
  googleCaptcha: {
    siteKey: '6LeuuJcUAAAAAJtpfdUpKvjxk62bbz3KCNVfGkuz',
  },
  intercom: {
    IntercomAppID: 'XXXXXXXXX',
  },
  intrack: {
    IntrackAppKey: 'XXXXXXXXX',
    IntrackAuthKey: 'XXXXXXXXX',
    IntrackPublicKey: 'XXXXXXXXX',
  },
  clarity: {
    projectId: 'XXXXXXXXXX',
  },
  webEngage: {
    licenseCode: '82617805',
  },
  facebook: {
    appId: '629792100977483',
  },
  sentry: {
    DSN: 'https://0f2b2605c4334568a8e46d435cc7f6f1@sentry.roomvu.com/5',
    environment: 'cypress',
  },
  stripe: {
    key: 'pk_test_SAS3NwDrUpHXlhtCUUVhe50t',
  },
};
